import { AnimatePresence } from 'framer-motion';
import React from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { Footer } from './components/layout/Footer';
import { Header } from './components/layout/Header';
import { ConfigProvider } from './hooks/useConfig';
import { AuthProvider } from './hooks/useCurrentUser';
import { UserDataProvider } from './hooks/useCurrentUserData';
import { AdminPage } from './pages/admin-pages';
import { AdminVideoUploadPage } from './pages/admin-pages/AdminFitnessTrailsTab';
import { ForgetPasswordPage } from './pages/auth-pages/ForgetPasswordPage';
import { LoginPage } from './pages/auth-pages/LoginPage';
import { RegisterPage } from './pages/auth-pages/RegisterPage';
import { CurrentWeekPage } from './pages/CurrentWeekPage';
import { UpcomingCoursesIframe } from './pages/iframe/UpcomingCoursesIframe';
import { JitsiCoursePage } from './pages/JitsiCoursePage';
import { CommonLandingPage } from './pages/landing-pages/CommonLandingPage';
import { ProfilePage } from './pages/ProfilePage';
import { UpcomingCoursesPage } from './pages/UpcomingCoursesPage';
import { NotFoundPage } from './pages/util-pages/NotFoundPage';

export const Routes: React.FC = () => {
  const location = useLocation();

  return (
    <ConfigProvider>
      <AuthProvider>
        <UserDataProvider>
          <AnimatePresence exitBeforeEnter>
            <Switch location={location} key={location.key}>
              <Route path="/login/:redirectUrl?">
                <LoginPage />
                <Footer textColor="white" />
              </Route>
              <Route exact={true} path="/password-reset">
                <ForgetPasswordPage />
                <Footer textColor="white" />
              </Route>
              <Route exact={true} path="/register">
                <RegisterPage />
                <Footer textColor="white" />
              </Route>
              <Route exact={true} path="/profile">
                <Header />
                <ProfilePage />
                <Footer />
              </Route>
              <Route exact={true} path="/upcoming-courses">
                <Header />
                <UpcomingCoursesPage />
                <Footer />
              </Route>
              <Route exact={true} path="/current-week">
                <Header />
                <CurrentWeekPage />
                <Footer />
              </Route>
              <Route exact={true} path="/admin">
                <Header />
                <AdminPage />
                <Footer />
              </Route>
              <Route exact={true} path="/public-course/:id/:roomTitle?">
                <JitsiCoursePage type="public" />
              </Route>
              <Route exact={true} path="/private-course/:id/:roomTitle?">
                <JitsiCoursePage type="private" />
              </Route>
              <Route exact={true} path="/">
                <Redirect to="/upcoming-courses" />
              </Route>
              <Route exact={true} path="/iframe/upcoming-courses">
                <UpcomingCoursesIframe target="_blank" />
              </Route>
              <Route exact={true} path="/admin/video-upload">
                <AdminVideoUploadPage />
              </Route>
              <Route exact={true} path="/landing">
                <CommonLandingPage />
              </Route>
              <Route>
                <Header />
                <NotFoundPage />
                <Footer />
              </Route>
            </Switch>
          </AnimatePresence>
        </UserDataProvider>
      </AuthProvider>
    </ConfigProvider>
  );
};
